import React from 'react';

import { IconButton, PopupMenu } from 'design-system-web';

import { useLabels } from '../../i18n/useLabels';
import type { SectionActionId } from '../../viewmodels/rowTypes';
import type { SectionViewModel } from '../../viewmodels/createSectionViewModel';

type Props = {
  viewModel: Pick<SectionViewModel, 'menuLabel' | 'menuEntries'>;
  onSelect: (entryId: SectionActionId) => void;
};

export function SectionActionsMenu({ viewModel, onSelect }: Props) {
  const { formatMessage } = useLabels();
  const menuLabel = formatMessage(viewModel.menuLabel);
  const items = viewModel.menuEntries.map(entry => ({
    label: formatMessage(entry.label),
    isDisabled: entry.isDisabled,
    tooltipText: entry.disabledReason
      ? formatMessage(entry.disabledReason)
      : undefined,
    onSelect: () => onSelect(entry.id),
  }));

  return (
    <PopupMenu
      placement="bottom-end"
      trigger={<IconButton icon="ellipsis-v" label={menuLabel} />}
      items={items}
    />
  );
}
